module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_2.b0398fef.png";